export const truncateString = (str: string, len: number, suffix = '') =>
  str.length > len ? `${str.slice(0, len)}${suffix}` : str;
